import EventBus from "../utils/EventBus";
import rm from "../utils/rm"
import { toast } from "../utils/toast";

//////// dev

// const doTaskInLoginState = (callback: (res: {success: boolean})=>void)=>{
//     callback({success: true})
// }

// const getUserHash = ()=>{
//     return "9BB16123F9F9EEA03C2D15335543C07DC4BB1269D27790CE6E00B8FB458FC40F8257FDC10450231763B7560A81956B2D";
// }

// const isLogin = ()=>{
//     return true;
// }

// const getUserInfo = ()=>{
//     return {
//         userid: 51670
//     }
// }

////// release

const doTaskInLoginState = (callback: (res: { success: boolean }) => void) => {
    const isLoginBefore = isLogin();
    rm.login((res) => {
        callback({ success: res.success });
        if (res.success !== isLoginBefore) {
            EventBus.send(EventBus.names.USER_LOGIN_STATE_CHANGE, res.userInfo || {}, true)
        }
    })
}

const getUserHash = () => {
    let hash = rm.getUserHashSync().userHash || '';
    return encodeURIComponent(decodeURIComponent(hash))
}

const isLogin = () => {
    return rm.getUserInfoSync().success && !!rm.getUserInfoSync().userInfo;
}

const getUserInfo = () => {
    return rm.getUserInfoSync().userInfo
}
const getUserInfoAsync = (cb: (userInfo: any) => void) => {
    rm.getUserInfo((res) => {
        cb(res.userInfo)
    })
}
const getPlaform = () => {
    const appName = rm.getEnv().app;
    let platform = rm.getEnv().platform.toLowerCase();
    if (platform === "ios") {
        platform = "iphone";
    } else if (platform === "harmonyos") {
        platform = "hos";
    }
    const isGooglePlay = rm.getSystemInfoSync().systemInfo?.apkChannel === "googleplay";
    if(isGooglePlay){
        platform = "android_gp";
    }
    return {
        platform: appName + "_" + platform,
        ...(isGooglePlay ? {
            "x-appstore": "googleplay"
        } :{})
    };
}


////////////////////

const getAuthHeader = () => {
    const header = {
        "accept": "application/json",
        "content-type": "application/json",
        "appver": rm.getSystemInfoSync().systemInfo?.appVer,
        ...getPlaform()
    };
    if (isLogin()) {
        Object.assign(header, {
            "userhash": getUserHash(),
        })
    }
    return header;
}

const userUtils = {
    doTaskInLoginState,
    getUserHash,
    isLogin,
    getUserInfo,
    getUserInfoAsync,
    getAuthHeader,
    getPlaform
}

export default userUtils